import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Icon, Logo, Mark, BlobField, Button } from "../components/ui";
import { familyService } from "../services/familyService";
import { validateForm } from "../utils/validate";

export default function SetPassword() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (
      !validateForm(e.currentTarget, [
        { name: "password", value: pw, label: "Password", required: true, minLength: 6 },
        { name: "confirm", value: confirm, label: "Confirm password", required: true,
          custom: (v) => (v && v !== pw ? "Those passwords don't match" : null) },
      ])
    ) {
      if (pw.length >= 6 && pw !== confirm) setError("Those passwords don't match.");
      else if (pw.length > 0 && pw.length < 6) setError("Password must be at least 6 characters.");
      return;
    }
    setBusy(true);
    try {
      const res = await familyService.setPassword(token, pw);
      if (res?.success) setDone(true);
      else setError(res?.msg || "This link is invalid or has expired.");
    } catch (err) {
      setError(err?.response?.data?.msg || "Something went wrong. Please try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-wrap">
      <div className="login-hero on-dark">
        <BlobField />
        <div className="login-hero-inner">
          <div className="hero-brand">
            <Mark size={52} variant="amber" />
            <Logo variant="white" height={44} />
          </div>
          <div className="hero-spacer">
            <p className="eyebrow on-dark">Family Portal</p>
            <h1 className="display hero-title">
              Let's set up your<br />secure password.
            </h1>
          </div>
          <p className="hero-tagline">Steps towards a bright future.</p>
        </div>
      </div>

      <div className="login-form-side">
        {!token ? (
          <div className="login-card auth-done">
            <h2>Missing link</h2>
            <p className="muted mt-12">
              This page needs the secure link from your approval email.
            </p>
            <div className="mt-24">
              <Button variant="ghost" block onClick={() => navigate("/login")}>Back to sign in</Button>
            </div>
          </div>
        ) : done ? (
          <div className="login-card auth-done">
            <span className="icon-circle lg icon-center"><Icon name="check" className="ico-28" /></span>
            <h2 className="mt-24">You're all set</h2>
            <p className="muted mt-12">
              Your password has been saved. You can now sign in to your family account.
            </p>
            <div className="mt-28">
              <Button variant="primary" block onClick={() => navigate("/login")}>Go to sign in</Button>
            </div>
          </div>
        ) : (
          <form className="login-card" onSubmit={submit} noValidate>
            <p className="eyebrow">Set your password</p>
            <h2 className="auth-h2">Create a password</h2>
            <p className="auth-intro">
              Choose a strong password of at least 6 characters.
            </p>

            {error && <div className="alert-soft">{error}</div>}

            <div className="form-field">
              <label className="field-label">New password</label>
              <input className="input" type="password" name="password" value={pw} onChange={(e) => setPw(e.target.value)}
                required minLength={6} placeholder="At least 6 characters" />
            </div>

            <div className="form-field--lg">
              <label className="field-label">Confirm new password</label>
              <input className="input" type="password" name="confirm" value={confirm} onChange={(e) => setConfirm(e.target.value)}
                required placeholder="Re-enter new password" />
            </div>

            <Button variant="primary" block type="submit" disabled={busy} iconRight={busy ? null : "check"}>
              {busy ? "Saving…" : "Save password"}
            </Button>

            <hr className="divider divider-lg" />
            <p className="signin-alt">
              <Link to="/login" className="link-strong">Back to sign in</Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
